import { createReducer } from '@reduxjs/toolkit';

import {
  loadPaymentRouteListSuccess,
  loadPaymentRouteStart,
  loadPaymentRoutingListSuccess,
  loadPaymentRoutingStart,
  resetPaymentRouteItem,
} from './actions';
import { IPaymentRoutingReducer } from './types';

const initialState: IPaymentRoutingReducer = {
  routing: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
  route: {
    isLoading: false,
    isLoaded: false,
    data: {},
  },
};

const PaymentRoutingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadPaymentRoutingStart, (state) => ({
      ...state,
      routing: {
        ...state.routing,
        isLoading: true,
      },
    }))
    .addCase(loadPaymentRoutingListSuccess, (state, action) => ({
      ...state,
      routing: {
        ...state.routing,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(loadPaymentRouteStart, (state) => ({
      ...state,
      route: {
        ...state.route,
        isLoading: true,
      },
    }))
    .addCase(loadPaymentRouteListSuccess, (state, action) => ({
      ...state,
      route: {
        ...state.route,
        isLoading: false,
        isLoaded: true,
        data: action.payload,
      },
    }))
    .addCase(resetPaymentRouteItem, (state) => ({
      ...state,
      route: {
        ...initialState.route,
      },
    }));
});

export default PaymentRoutingReducer;
